import {ReactNode} from 'react';

import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Types.
 */

export enum AdminSetupGuideScreensEnum {
  DEFAULT = 'default', // Have the setup guide compute the appropriate screen.
  DEMOS = 'demos',
  SETUP = 'setup',
  MORE = 'more',
}

// Everything but "default" (which dynamically computes the appropriate screen).
export type AdminSetupGuideConcreteScreen =
  | AdminSetupGuideScreensEnum.DEMOS
  | AdminSetupGuideScreensEnum.SETUP
  | AdminSetupGuideScreensEnum.MORE;

export enum FluSetupGuideScreensEnum {
  DEFAULT = 'default', // Have the setup guide compute the appropriate screen.
  GET_STARTED = 'get_started',
  MORE = 'more',
}

// Everything but "default" (which dynamically computes the appropriate screen).
export type FluSetupGuideConcreteScreen =
  | FluSetupGuideScreensEnum.GET_STARTED
  | FluSetupGuideScreensEnum.MORE;

export interface SetupGuideResourceTaskResource {
  key: string;
  title: ReactNode;
  displayName: string;
  description?: ReactNode;
  color?: PaletteColorsEnum;
  icon: IconName;
  link: string;
  isInternal?: boolean;
}

export interface SetupGuideResourceTaskDefinition {
  key: string;
  title: ReactNode;
  image: string;
  resources: ReadonlyArray<SetupGuideResourceTaskResource>;
}
